import Vue from 'vue'
import { Button } from 'element-ui'
import { Form, FormItem } from 'element-ui'
import { Input, } from 'element-ui'
import { Container, Aside, Header, Footer, Main } from 'element-ui'
import { Menu, MenuItem, Submenu } from 'element-ui'
import { Tooltip } from 'element-ui'
import { Tag } from 'element-ui'
import { Breadcrumb, BreadcrumbItem } from 'element-ui'
import { Table, TableColumn } from 'element-ui'
import { Pagination } from 'element-ui'
// import { Card } from 'element-ui'
import { Dialog } from 'element-ui'
import { Select, Option } from 'element-ui'
import { Message, MessageBox } from 'element-ui'
import { Tree } from 'element-ui'
import { Row, Col } from 'element-ui'


Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm


Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Tooltip)
Vue.use(Tag)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
    // Vue.use(Card)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tree)
Vue.use(Row)
Vue.use(Col)